<template>

    <Head title="Notificações" />


    <div class="shadow_box rounded-lg p-6 mt-4">
        <h1 class="mb-6 text-2xl text-gray-777 font-roboto uppercase">
            <span class="whitespace-nowrap overflow-hidden">
                Notificações
            </span>
        </h1>
        <data-table 
            v-model:columns="colunsProviderNotifications"
            no-data-label="Nenhuma notificação cadastrada"
            no-result-label="Nenhuma notificação encontrada"
            :route="'activity_management/list'">
                <!-- <template #table.cell.content.actions="{ value, row }">
                    <div class="inline-grid gap-4 ">

                        <button
                            class="btn-purple font-normal text-xs px-6 py-2.5">
                                Ver Relatório
                                <font-awesome-icon icon="fa-solid fa-angle-right" class="pl-2" />
                        </button>
                    </div>
                </template> -->
        </data-table>
    </div>

</template>


<script>

import { Head } from '@inertiajs/inertia-vue3'


import ProviderLayout from '@/Shared/ProviderLayout'
import DataTable from '@/Shared/DataTable'


import { colunsProviderNotifications } from './tableColumns'

export default {
    components: {
        Head,
        DataTable,
    },

    layout: ProviderLayout,

    setup() {
        return {
            colunsProviderNotifications,
        }
    },
}

</script>
